import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { adminApi, formatApiError } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = غير معروف
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // إذا كنّا عائدين من Google OAuth، دع AuthCallback يُنشئ الجلسة أولًا
    if (
      typeof window !== "undefined" &&
      window.location.hash?.includes("session_id=")
    ) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await adminApi.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch {}
    // نظّف أي بقايا من نظام JWT القديم
    localStorage.removeItem("rush_admin_token");
    setUser(false);
  }, []);

  const value = useMemo(
    () => ({
      user,
      loading,
      logout,
      setUser,
      refresh: checkAuth,
      isAuthenticated: !!user,
    }),
    [user, loading, logout, checkAuth]
  );

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  }
  return ctx;
};
